import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CtxTag, CtxSyntaxCheck } from './ctx-tag-builder.model';
import { Observable } from 'rxjs';
import { UrlPrefix } from "../../common/constants/url-prefix.constants";
import { Attribute } from '../../../product-module/add-edit-attribute/attribute.model';

@Injectable()

export class CtxTagBuilderService {
    constructor(private http: HttpClient) { }

    getInitData(): Observable<Array<CtxTag>> {
        return this.http.get<Array<CtxTag>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/formulaBuilder/initialCTXTagS`);
    }

    getTagByIndex(index: number, productId: number, containerName: string, containerId: number): Observable<CtxTag> {
        return this.http.get<CtxTag>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/formulaBuilder/selectedCTXTag?tagIndex=${index}&productId=${productId}&containerName=${containerName}&containerId=${containerId}`);
    }

    getFirstLevelQuoteObjects(index: number, productId: number, containerName: string, containerId: number): Observable<CtxTag> {
        return this.http.get<CtxTag>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/formulaBuilder/rootQuoteObject?tagIndex=${index}&productId=${productId}`);
    }

    getOtherLevelsObjectsForSelectedQuoteObject(index: number, childIndex: number, productId: number, containerName: string, containerId: number): Observable<Array<CtxTag>> {
        return this.http.get<Array<CtxTag>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/formulaBuilder/otherQuoteObjects?tagIndex=${index}&childTagIndex=${childIndex}&productId=${productId}`);
    }

    checkCtxTagSyntax(formula: string): Observable<CtxSyntaxCheck> {
        return this.http.post<CtxSyntaxCheck>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/formulaBuilder/checkCtxTagSyntax`, JSON.stringify(formula));
    }

    getAttribute(attributeId: number): Observable<Attribute> {
        return this.http.get<Attribute>(`api/products/v1/attributes/${attributeId}`);
    }
    
}
